import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PipelineAoiPanelService } from './pipeline-aoi-panel.service';
import { PipelineAoiDetailDialogComponent } from './pipeline-aoi-detail-dialog.component';

/**
 * Headless host component that listens to PipelineAoiPanelService.featureDetailTrigger$
 * and opens the AOI detail dialog. Place inside the map container.
 */
@Component({
  selector: 'lib-pipeline-aoi-panel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class PipelineAoiPanelComponent implements OnInit, OnDestroy {
  private readonly panelService = inject(PipelineAoiPanelService);
  private readonly dialog = inject(MatDialog);
  private readonly subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.subscriptions.push(
      this.panelService.featureDetailTrigger$.subscribe((feature) => {
        this.dialog.open(PipelineAoiDetailDialogComponent, {
          data: feature,
          autoFocus: false,
          width: '480px',
        });
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
